import { LanguageState, DefaultLanguageState } from "../state";

import { UpdateLanguageAction } from './languageActions';
import * as ActionTypes from '../action-types';
import { Reducer } from "redux";

type Action = UpdateLanguageAction;

const updateState : Reducer<LanguageState, Action> = (state: LanguageState = DefaultLanguageState, action: Action) => {
    switch(action.type) {
        case ActionTypes.UPDATE_LANGUAGE: 
            return {
                ...state,
                currentLanguage: action.language
            }
        default: 
            return state;
    }
}

export default updateState;